module.exports = __webpack_public_path__ + "static/media/1021200.553c4f84.png";